var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input--btn" }, [
    _vm.agentLiteral
      ? _c("p", { staticClass: "text-small black mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t(_vm.agentLiteral))),
        ])
      : _c("p", { staticClass: "text-small-bold black mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t(_vm.literal))),
        ]),
    _c(
      "ul",
      { staticClass: "input__wrapper" },
      _vm._l(_vm.options, function (option) {
        return _c("li", [
          _c(
            "label",
            {
              class: {
                "input--btn--icon": option.agent_icon,
                checked: _vm.isChecked(option.key),
              },
              on: {
                click: function ($event) {
                  return _vm.handleClick(option.key)
                },
              },
            },
            [
              _c(
                "div",
                [
                  option.agent_icon
                    ? _c("svgicon", {
                        attrs: {
                          icon: option.agent_icon,
                          height: "42",
                          width: "auto",
                        },
                      })
                    : _vm._e(),
                  _c("p", { staticClass: "text-small blueDark" }, [
                    _vm._v(_vm._s(_vm.$t(option.literal))),
                  ]),
                  _vm.type === "checkbox"
                    ? _c("input", {
                        attrs: {
                          type: "checkbox",
                          for: _vm.name,
                          name: _vm.name,
                        },
                        domProps: {
                          value: option.key,
                          checked: _vm.isChecked(option.key),
                        },
                      })
                    : _c("input", {
                        attrs: { type: "radio", name: _vm.name },
                        domProps: {
                          value: option.key,
                          checked: _vm.isChecked(option.key),
                        },
                      }),
                ],
                1
              ),
            ]
          ),
        ])
      }),
      0
    ),
    _c(
      "p",
      {
        staticClass: "errorMsg text-small mg mg--t-1",
        class: { errorVisible: _vm.inputError },
      },
      [_vm._v(_vm._s(_vm.$t("claim.details.errorMsgInputTxt")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }